// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"45e90b2a","635":"c752c7dd"}[chunkId] + ".chunk.js";
};